import { css } from '@emotion/css'
import { borderRadius, breakpoint, colors, fontSize, fontWeight, mediaQueryHelper, spacing } from '@offerzen/pinata'

const styles = {
  list: css({
    listStyleType: 'none',
    padding: 0,
    margin: 0,
    width: '95%',

    [mediaQueryHelper(breakpoint.tablet)]: {
      width: '100%',
    },

    'li + li': {
      marginTop: spacing.default,
    },

    'li > *': {
      margin: 0,
    },
  }),

  roleItem: css({
    display: 'grid',
    gridRowGap: spacing.small,
    gridTemplateAreas: `
      "role experience"
      "progress progress"
    `,
  }),

  role: css({
    gridArea: 'role',
    color: colors.scorpion,
    fontSize: fontSize.default,
    lineHeight: 1.2,
    fontWeight: fontWeight.medium,

    [mediaQueryHelper(breakpoint.phone)]: {
      fontSize: fontSize.small,
    },
  }),

  progress: css({
    gridArea: 'progress',
    width: '100%',
    height: 8,
    background: colors.porcelain,
    borderRadius: borderRadius.medium,
    position: 'relative',

    '& > div': {
      background: colors.geyser,
      borderRadius: borderRadius.medium,
      position: 'absolute',
      height: 8,
      minWidth: 8,
    },
  }),

  experience: css({
    justifySelf: 'end',
    fontSize: fontSize.default,
    color: colors.jumbo,
    lineHeight: 1.2,
    fontWeight: fontWeight.regular,

    [mediaQueryHelper(breakpoint.phone)]: {
      fontSize: fontSize.small,
    },
  }),
}

export default styles

export const highlightTheme = () => {
  return css({
    background: `${colors.hawkesBlue} !important`,

    '& > div': {
      background: `${colors.cornflowerBlue} !important`,
    },
  })
}
